import store from '@/store/index'
import { getCurrentDomain } from '@/utils'
import { ACCESS_TOKEN, BASE_URL, ACCESS_TOKEN_NAME } from '../../constant/index'

export default {
  data() {
    return {
      formKey: null
    }
  },
  created() {
    // 写入值到localStorage 给组件使用
    if (store.state.user.token) {
      localStorage.setItem(ACCESS_TOKEN, store.state.user.token)
    }
    localStorage.setItem('FORM-SUPPORT', process.env['VUE_APP_TITLE'])
    localStorage.setItem(ACCESS_TOKEN_NAME, 'Authorization')
    if (process.env['VUE_APP_API_ROOT']) {
      localStorage.setItem(BASE_URL, process.env['VUE_APP_API_ROOT'])
    } else {
      localStorage.setItem(BASE_URL, getCurrentDomain())
    }
  }
}
